export const DISCOVER_LIST_TAGS_DELIMITER = '||';
